<template>
  <ul
    v-if="items && items.length"
    :class="[
      'breadcrumb',
      {
        'breadcrumb__alignment--center': alignment === 'center',
        'breadcrumb__alignment--start': alignment === 'left',
        'breadcrumb__alignment--end': alignment === 'right',
        'breadcrumb__alignmentMobile--center': alignmentMobile === 'center',
        'breadcrumb__alignmentMobile--start': alignmentMobile === 'left',
        'breadcrumb__alignmentMobile--end': alignmentMobile === 'right',
      },
    ]"
  >
    <li
      v-for="(breadcrumb, index) in items"
      :key="index"
      class="breadcrumb__item"
    >
      <a
        v-if="breadcrumb.href"
        class="breadcrumb__link"
        :style="{ color: textColor }"
        :href="breadcrumb.href"
      >{{ breadcrumb.item }}</a>
      <span
        v-else
        class="breadcrumb__link"
        :style="{ color: textColor }"
      >{{ breadcrumb.item }}</span>
      <c-icon
        v-if="index < items.length - 1"
        name="breadcrumb-arrow"
        size="ssm"
        :color="iconColor"
      />
    </li>
  </ul>
</template>

<script>
import CIcon from '@ions/icon/icon.vue'

export default {
  name: 'breadcrumb',
  components: { CIcon },
  props: {
    items: {
      type: Array,
    },
    alignment: {
      type: String,
    },
    alignmentMobile: {
      type: String,
    },
    textColor: {
      type: String,
    },
    iconColor: {
      type: String,
    },
  },
}
</script>

<style scoped lang="scss">
.breadcrumb {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding-inline-start: 0;

  &__alignment {
    &--center {
      justify-content: center;
    }

    &--start {
      justify-content: flex-start;
    }

    &--end {
      justify-content: flex-end;
    }
  }

  &__alignmentMobile {
    &--center {
      @media screen and (max-width: 992px) {
        justify-content: center;
      }
    }

    &--start {
      @media screen and (max-width: 992px) {
        justify-content: flex-start;
      }
    }

    &--end {
      @media screen and (max-width: 992px) {
        justify-content: flex-end;
      }
    }
  }

  &__item {
    display: flex;
  }

  &__link {
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.125rem;
    text-decoration: none;
    color: inherit;
  }
}
</style>
